// extracted by mini-css-extract-plugin
export default {"moreButton":"AudienceList_moreButton__kKqSF","row":"AudienceList_row__pbSQc","pointer":"AudienceList_pointer__KR3kD","cohort":"AudienceList_cohort__1TS4j"};